import PitchControl from './PitchControl';
import RotateControl from './RotateControl';
import Toggle3D from './Toggle3D';

interface ThreeDControlsProps {
    is3D: boolean;
    setIs3D: SetState<boolean>;
    map: mapboxgl.Map | undefined;
    userLayers: UserLayer[] | undefined;
}

export function ThreeDControls({is3D, setIs3D, map, userLayers}: ThreeDControlsProps) {
    return (
        <>
            {is3D && <PitchControl map={map} />}
            {is3D && <RotateControl map={map} />}
            {map && <Toggle3D map={map} is3D={is3D} setIs3D={setIs3D} userLayers={userLayers} />}
        </>
    );
}
